module.exports = __webpack_public_path__ + "img/morrisons_nhs_foodbox.ac3c80de.webp";